import React from 'react'
import Tudu from './Tudu'

export default function TuduList({ tudus, toggleTudu }) {
  
    return (
    
        tudus.map(tudu => {

            return <Tudu key={ tudu.id } toggleTudu={ toggleTudu } tudu={ tudu } />

        })
    
    )

};
